import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import type { ComponentCommonFaqComponent } from '@edwin-group/people-graphql';
import classNames from 'classnames';

export default function DefaultContentTemplateFaq({
  component,
  text = 'FAQ',
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonFaqComponent;
  text?: string;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  return (
    <div
      className={classNames('flex flex-col gap-sh-30 font-haffer', className, {
        'my-0': isDefaultContentTemplate,
        'my-sh-30': !isDefaultContentTemplate,
      })}>
      <h1 className="font-haffer text-sh-lg font-bold text-black-200">{text}</h1>
      <Accordion type="single" collapsible className="flex flex-col">
        {component?.faq?.map((faq, index) => (
          <AccordionItem
            key={`faq-${index}`}
            value={faq?.title ? `${faq.title}-${index}` : `faq-${index}`}
            className="border-none">
            <AccordionTrigger
              iconVariant="plus-minus"
              className="min-h-[72px] items-center p-sh-16 font-haffer text-sh-16-38 font-bold text-black-200">
              {faq?.title}
            </AccordionTrigger>
            <AccordionContent className="px-[59px] pb-sh-16 pt-0">
              <p className="font-haffersq text-sh-14-20 font-normal text-dark-grey">{faq?.description}</p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
